import { useGameStore } from '../store/gameStore';

export function DevTools() {
  const actions = useGameStore((state) => state.actions);
  if (!import.meta.env.DEV) return null;
  return (
    <details className="dev-tools">
      <summary>开发调试工具</summary>
      <button onClick={() => actions.debugAdvanceTime(4 * 60 * 60 * 1000)}>作物推进4小时</button>
      <button onClick={() => actions.debugAddCoins(1000)}>增加1000金币</button>
    </details>
  );
}
